import { httpClient } from '../../../../net/httpClient';
import UrlConfig from '../../../../net/UrlConfig';

import {
    START_QUERY_GROUP_DIRSH,
    QUERY_GROUP_DIRSH_SUCCESS,
    QUERY_GROUP_DIRSH_FAILURE,
    INIT_QUERY_GROUP_DIRSH_ACTION_STATUS,
    GROUP_DIRSH_QUERY_CHANGE_INPUT,
    SELECT_GROUP_DIRSH,
    OPEN_ADD_OR_EDIT_GROUP_DIRSH_MODAL,
    RESET_ADD_OR_EDIT_GROUP_DIRSH_MODAL,
    ADD_OR_EDIT_GROUP_DIRSH_CHANGE_INPUT,
    START_SUBMIT_ADD_GROUP_DIRSH,
    SUBMIT_ADD_GROUP_DIRSH_SUCCESS,
    SUBMIT_ADD_GROUP_DIRSH_FAILURE,
    INIT_SUBMIT_ADD_GROUP_DIRSH_ACTION_STATUS,
    START_SUBMIT_UPDATE_GROUP_DIRSH,
    SUBMIT_UPDATE_GROUP_DIRSH_SUCCESS,
    SUBMIT_UPDATE_GROUP_DIRSH_FAILURE,
    INIT_SUBMIT_UPDATE_GROUP_DIRSH_ACTION_STATUS,
    OPEN_DEL_GROUP_DIRSH_MODAL,
    RESET_DEL_GROUP_DIRSH_MODAL,
    START_SUBMIT_DEL_GROUP_DIRSH,
    SUBMIT_DEL_GROUP_DIRSH_SUCCESS,
    SUBMIT_DEL_GROUP_DIRSH_FAILURE,
    INIT_SUBMIT_DEL_GROUP_DIRSH_ACTION_STATUS,
} from './GroupDirShConstants';

function startQueryGroupDirSh() {
    return { type: START_QUERY_GROUP_DIRSH };
}

export function queryGroupDirSh() {
    return function(dispatch) {
        dispatch(startQueryGroupDirSh());
        httpClient
            .get(UrlConfig.QUERY_GROUP_DIRSH)
            .then(resp => dispatch(queryGroupDirShSuccess(resp)))
            .catch(err => dispatch(queryGroupDirShFailure(err)));
    };
}

function queryGroupDirShSuccess(resp) {
    return {
        type: QUERY_GROUP_DIRSH_SUCCESS,
        payload: resp,
    };
}

function queryGroupDirShFailure(err) {
    return {
        type: QUERY_GROUP_DIRSH_FAILURE,
        payload: err,
    };
}

export function initQueryGroupDirShActionStatus() {
    return { type: INIT_QUERY_GROUP_DIRSH_ACTION_STATUS };
}

export function groupDirShQueryChangeInput(input) {
    return {
        type: GROUP_DIRSH_QUERY_CHANGE_INPUT,
        payload: input,
    };
}

export function selectGroupDirSh(array) {
    return {
        type: SELECT_GROUP_DIRSH,
        payload: array,
    };
}

export function openAddOrEditGroupDirShModal(mode, data) {
    return {
        type: OPEN_ADD_OR_EDIT_GROUP_DIRSH_MODAL,
        payload: { mode, data },
    };
}

export function resetAddOrEditGroupDirShModal() {
    return {
        type: RESET_ADD_OR_EDIT_GROUP_DIRSH_MODAL,
    };
}

export function addOrEditGroupDirShChangeInput(input) {
    return {
        type: ADD_OR_EDIT_GROUP_DIRSH_CHANGE_INPUT,
        payload: input,
    };
}

function startSubmitAddGroupDirSh() {
    return { type: START_SUBMIT_ADD_GROUP_DIRSH };
}

export function submitAddGroupDirSh(data) {
    return function(dispatch) {
        dispatch(startSubmitAddGroupDirSh());
        httpClient
            .post(UrlConfig.SUBMIT_ADD_GROUP_DIRSH, data)
            .then(resp => dispatch(submitAddGroupDirShSuccess(resp)))
            .catch(err => dispatch(submitAddGroupDirShFailure(err)));
    };
}

function submitAddGroupDirShSuccess(resp) {
    return {
        type: SUBMIT_ADD_GROUP_DIRSH_SUCCESS,
        payload: resp,
    };
}

function submitAddGroupDirShFailure(err) {
    return {
        type: SUBMIT_ADD_GROUP_DIRSH_FAILURE,
        payload: err,
    };
}

export function initSubmitAddGroupDirShActionStatus() {
    return { type: INIT_SUBMIT_ADD_GROUP_DIRSH_ACTION_STATUS };
}

function startSubmitUpdateGroupDirSh() {
    return { type: START_SUBMIT_UPDATE_GROUP_DIRSH };
}

export function submitUpdateGroupDirSh(data) {
    return function(dispatch) {
        dispatch(startSubmitUpdateGroupDirSh());
        httpClient
            .post(UrlConfig.SUBMIT_UPDATE_GROUP_DIRSH, data)
            .then(resp => dispatch(submitUpdateGroupDirShSuccess(resp)))
            .catch(err => dispatch(submitUpdateGroupDirShFailure(err)));
    };
}

function submitUpdateGroupDirShSuccess(resp) {
    return {
        type: SUBMIT_UPDATE_GROUP_DIRSH_SUCCESS,
        payload: resp,
    };
}

function submitUpdateGroupDirShFailure(err) {
    return {
        type: SUBMIT_UPDATE_GROUP_DIRSH_FAILURE,
        payload: err,
    };
}

export function initSubmitUpdateGroupDirShActionStatus() {
    return { type: INIT_SUBMIT_UPDATE_GROUP_DIRSH_ACTION_STATUS };
}

export function openDelGroupDirShModal(data) {
    return {
        type: OPEN_DEL_GROUP_DIRSH_MODAL,
        payload: data,
    };
}

export function resetDelGroupDirShModal() {
    return {
        type: RESET_DEL_GROUP_DIRSH_MODAL,
    };
}

function startSubmitDelGroupDirSh() {
    return { type: START_SUBMIT_DEL_GROUP_DIRSH };
}

export function submitDelGroupDirSh(data) {
    return function(dispatch) {
        dispatch(startSubmitDelGroupDirSh());
        httpClient
            .post(UrlConfig.SUBMIT_DEL_GROUP_DIRSH, data)
            .then(resp => dispatch(submitDelGroupDirShSuccess(resp)))
            .catch(err => dispatch(submitDelGroupDirShFailure(err)));
    };
}

function submitDelGroupDirShSuccess(resp) {
    return {
        type: SUBMIT_DEL_GROUP_DIRSH_SUCCESS,
        payload: resp,
    };
}

function submitDelGroupDirShFailure(err) {
    return {
        type: SUBMIT_DEL_GROUP_DIRSH_FAILURE,
        payload: err,
    };
}

export function initSubmitDelGroupDirShActionStatus() {
    return { type: INIT_SUBMIT_DEL_GROUP_DIRSH_ACTION_STATUS };
}
